<template>
    <ideo-form-group :label="$t('[[[Slajder]]]')" :invalid-feedback="form.$errors.first('settings.slider')" :state="form.$errors.state('settings.slider')" required>
        <ideo-autocomplete
            v-model="form.settings.slider"
            name="settings.slider"
            track-by="id"
            :placeholder="$t('[[[zacznij pisać aby wyszukać slajder...]]]')"
            :fetch="(id: number) => fetchSlider(id)"
            :search="(query: string, limit: number) => searchSliders(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </ideo-autocomplete>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { Option } from '@/helpers/Interfaces';
import { FormType } from '@/helpers/Form';
import { ValidatableComponent } from '@/components/cms';
import merge from 'lodash/merge';
import SlidersService, { ListItemModel } from '@/modules/cms/sliders/services/SlidersService';

interface FormSettings
{
    settings: any;
}

@Options({
    name: 'widget-slider-settings'
})
export default class SliderSettings extends Vue implements ValidatableComponent
{
    @Prop() public modelValue!: any;

    public defaults: any = {
        slider: ''
    };

    public get form(): FormType<FormSettings>
    {
        return this.modelValue;
    }

    public get quantity(): Option<number>[]
    {
        return new Array(10).fill(null).map((value, index) =>
        {
            return { value: index + 1, text: (index + 1).toString() };
        });
    }

    public async created(): Promise<void>
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async validate(): Promise<void>
    {
        this.form.validate(schema => ({
            settings: schema.object({
                slider: schema.string().required(this.$t('[[[Wybranie strony jest wymagane]]]'))
            })
        }));
    }

    public async fetchSlider(id: number): Promise<ListItemModel>
    {
        if (id != 0)
        {
            const response = await SlidersService.fetchAutocompleteModel(id);

            return response || null;
        }

        return null;
    }

    public async searchSliders(query: string, limit: number): Promise<ListItemModel[]>
    {
        return await SlidersService.getAutocompleteList(query, limit);
    }
}
</script>
